import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Badge } from "@faire/web--source/slate/deprecated/Badge";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Tooltip } from "@faire/web--source/slate/Tooltip";
import { PortalTooltip } from "@faire/web--source/slate/Tooltip/PortalTooltip";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";
import { TopShopTooltipContents } from "./TopShopTooltipContents";
export var TopShopTileBadge = function(props) {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _props_content;
    return /*#__PURE__*/ _jsx(MaybePortalTooltip, {
        placement: "bottom",
        className: props.className,
        tooltipZIndex: 1005,
        tooltip: /*#__PURE__*/ _jsx(Tooltip, {
            width: 308,
            position: "bottom",
            isOpen: true,
            icon: /*#__PURE__*/ _jsx("div", {}),
            children: /*#__PURE__*/ _jsx(TopShopTooltipContents, {})
        }),
        children: /*#__PURE__*/ _jsx(StyledBadge, {
            content: (_props_content = props.content) !== null && _props_content !== void 0 ? _props_content : strictLocalize({
                id: "RhE5gS",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Top Shop"
                    }
                ]
            }),
            backgroundColor: Core.surface.inverse
        })
    });
};
var StyledBadge = styled(Badge).withConfig({
    componentId: "sc-82a58e0d-0"
})([
    "&&{",
    ";font-weight:500;padding:",
    ";cursor:pointer;}"
], TypographyStyles({
    variant: "labelSansRegular"
}), getSpacing(3, 7));
var MaybePortalTooltip = function(props) {
    var isTabletAndBelow = useViewport().isTabletAndBelow;
    if (isTabletAndBelow) {
        return /*#__PURE__*/ _jsx("div", {
            className: props.className,
            children: props.children
        });
    }
    return /*#__PURE__*/ _jsx(PortalTooltip, _object_spread({}, props));
};
